
export type UpdateDraftLectureMarkdownBody = {
  /** 강의 내용 마크다운 파일 */
  markdownFile?: Blob;
};
